import { BenefitSummaryList } from './benefit-summary';
import {Document} from './document';

export class EnrollmentCategoryOptions {
	categoryID: number;
	isAddAvailable: boolean;
	isReplaceAvailable: boolean;
	isExistingBenefitEdit: boolean;
	isFSAReEnrollAvailable: boolean;
	isTermAvailable: boolean;
	isCancelAvailable: boolean;
	isWaiveAvailable: boolean;
	isAddWaiveBenefitAvailable: boolean;
	isWaiveExistingBenefitOrRequestAvailable: boolean;
	isHTMLAvailable: boolean;
	isHTMLAvailableOptions: boolean;
	isNoChangeAvailable: boolean;
	waiveBenefitNumber: number;
	genericBenefitSummaryModel: BenefitSummaryList;
	benefitCompareModel: BenefitCompareModel[];
	isWidgetAvailable: boolean;
	isFauxCategory: boolean;
	isAnyInCategoryAvailable: boolean;
	fauxHTML: string;
	displayDefaultFauxHTML: boolean;
	categoryHTML: string;

	constructor() {
		this.categoryID = null;
		this.isAddAvailable = false;
		this.isReplaceAvailable = false;
		this.isExistingBenefitEdit = false;
		this.isFSAReEnrollAvailable = false;
		this.isTermAvailable = false;
		this.isCancelAvailable = false;
		this.isWaiveAvailable = false;
		this.isAddWaiveBenefitAvailable = false;
		this.isWaiveExistingBenefitOrRequestAvailable = false;
		this.isHTMLAvailable = false;
		this.isNoChangeAvailable = false;
		this.isWidgetAvailable = false;
		this.isFauxCategory = false;
		this.isAnyInCategoryAvailable = false;
		this.waiveBenefitNumber = null;
		this.genericBenefitSummaryModel = new BenefitSummaryList();
		this.benefitCompareModel = new Array<BenefitCompareModel>();
		this.fauxHTML = null;
		this.displayDefaultFauxHTML = false;
		this.categoryHTML = null;
	}
}

export class BenefitCompareModel {
	categoryName: string;
	categoryId: number;
	benefitCompareList: BenefitComparisonList[];

	constructor() {
		this.categoryName = null;
		this.categoryId = null;
		this.benefitCompareList = new Array<BenefitComparisonList>();
	}
}

export class BenefitComparisonList {
	constructor() { }
}

export class MemberBenefitFlyout {
	totalDeductionAmount: number;
	totalPretaxAmount: number;
	totalPosttaxAmount: number;
	memberBenefitCards: MemberBenefitCard[];

	constructor() {
		this.totalDeductionAmount = 0;
		this.totalPretaxAmount = 0;
		this.totalPosttaxAmount = 0;
		this.memberBenefitCards = new Array<MemberBenefitCard>();
	}
}

export class MemberBenefitCard {
	memberBenefitName: string;
	pretaxAmount: string;
	posttaxAmount: string;

	constructor() {
		this.memberBenefitName = null;
		this.pretaxAmount = null;
		this.posttaxAmount = null;
	}
}

export class BenefitCategories {
	benefitCategoriesModelDetails: BenefitCategoriesDetail[];
	companyDocuments: Document[];

	constructor() {
		this.benefitCategoriesModelDetails = new Array<BenefitCategoriesDetail>();
		this.companyDocuments = new Array<Document>();
	}
}

export class BenefitCategoriesDetail {
	categoryName: string;
	categoryId: number;
	benefitDocuments: Document[];

	constructor() {
		this.categoryName = null;
		this.categoryId = null;
		this.benefitDocuments = new Array<Document>();
	}
}

export class EnrollmentCategoryOptionManager {
	enrollmentCategoryOptionsModel: EnrollmentCategoryOptions;
	memberBenefitFlyoutModel: MemberBenefitFlyout;
	benefitCategoriesModel: BenefitCategories;
	version: string;

	constructor() {
		this.enrollmentCategoryOptionsModel = new EnrollmentCategoryOptions();
		this.memberBenefitFlyoutModel = new MemberBenefitFlyout();
		this.benefitCategoriesModel = new BenefitCategories();
		this.version = null;
	}
}

